import { KEYWORDS_SCOPE } from "@/enums/keywords";

export default {
  scope: KEYWORDS_SCOPE.COMPANY,
  keywords: []
  // BELOW: future extension for other scopes
  // group: null,
  // facility: null,
};
